const getDefaultState = () => ({
  allIds: [],
  byId: {}
});

const state = getDefaultState();

const getters = {
  find: state => id => state.byId[id],
  list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  addOrderDeals: ({ commit }, orderDeals) => {
    orderDeals.forEach(od => {
      commit('add', od);
    });
  }
};

const mutations = {
  add: (state, orderProduct) => {
    state.byId[orderProduct.id] = orderProduct;
    if (state.allIds.includes(orderProduct.id)) return;
    state.allIds.push(orderProduct.id);
  },
  reset: state => Object.assign(state, getDefaultState())
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
